import React from 'react';
import { Outlet } from 'react-router-dom';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import Navbar from '../components/common/Navbar';
import Footer from '../components/common/Footer';
import { useLocalStorage } from '../hooks/useLocalStorage';

const CookieConsent: React.FC<{ onAccept: () => void }> = ({ onAccept }) => (
  <div className="fixed bottom-0 left-0 right-0 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 p-4 shadow-lg z-50">
    <div className="container mx-auto flex items-center justify-between">
      <p className="text-sm text-gray-600 dark:text-gray-400">
        We use cookies to enhance your experience. By continuing to visit this site you agree to our use of cookies.
      </p>
      <button
        onClick={onAccept}
        className="ml-4 p-2 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
      >
        <XIcon className="h-5 w-5" />
      </button>
    </div>
  </div>
);

const AppLayout: React.FC = () => {
  const [cookiesAccepted, setCookiesAccepted] = useLocalStorage('cookies_accepted', false);

  return (
    <motion.div 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="min-h-screen flex flex-col"
    >
      <Navbar />
      
      <main className="flex-1">
        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.1 }}
          className="h-full"
        >
          <Outlet />
        </motion.div>
      </main>
      
      <Footer />
      
      {!cookiesAccepted && (
        <CookieConsent onAccept={() => setCookiesAccepted(true)} />
      )}
    </motion.div>
  );
};

export default AppLayout;